import React from 'react';
import { View, Text, Modal, ActivityIndicator, StyleSheet, Platform } from 'react-native';
import theme from '../config/theme';

type Props = {
  visible: boolean;
  message?: string;
  hint?: string;
  progress?: number;
  progressLabel?: string;
};

const WebLoadingOverlay: React.FC<Props> = ({ visible, message, hint, progress, progressLabel }) => {
  if (Platform.OS !== 'web' || !visible) return null;
  return (
    <Modal transparent visible>
      <View style={styles.overlay}>
        <View style={styles.container}>
          <ActivityIndicator size="large" color={theme.colors.primary.default} />
          {progress !== undefined && (
            <>
              <View style={styles.progressTrack} accessibilityLabel={`Progresso ${progress}%`}>
                <View style={[styles.progressFill, { width: `${progress}%` }]} />
              </View>
              {progressLabel && <Text style={styles.progressLabel}>{progressLabel}</Text>}
            </>
          )}
          {message && <Text style={styles.text}>{message}</Text>}
          {hint && <Text style={styles.hint}>{hint}</Text>}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFill,
    backgroundColor: 'rgba(0,0,0,0.3)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: theme.zIndex.overlay,
  },
  container: {
    backgroundColor: theme.colors.background.primary,
    borderRadius: theme.borderRadius.md,
    padding: theme.spacing.lg,
    alignItems: 'center',
    minWidth: 220,
  },
  text: {
    marginTop: theme.spacing.md,
    color: theme.colors.text.primary,
    fontSize: theme.fontSizes.md,
    textAlign: 'center',
  },
  hint: {
    marginTop: theme.spacing.sm,
    color: theme.colors.text.secondary,
    fontSize: theme.fontSizes.sm,
    textAlign: 'center',
    lineHeight: 20,
  },
  progressTrack: {
    width: '100%',
    height: 10,
    marginTop: theme.spacing.lg,
    backgroundColor: theme.colors.background.tertiary,
    borderRadius: theme.borderRadius.circular,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: theme.colors.primary.default,
    borderRadius: theme.borderRadius.circular,
  },
  progressLabel: {
    marginTop: theme.spacing.sm,
    color: theme.colors.text.tertiary,
    fontSize: theme.fontSizes.xs,
    textAlign: 'center',
  },
});

export default WebLoadingOverlay;
